// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-5f63573d]{outline:2px dashed grey;outline-offset:-10px;padding:30px 10px;min-height:200px;position:relative;border-radius:4px;background:#161d31;height:100%}.action-button-custom-class[data-v-5f63573d]:hover{background:rgba(22,29,49,.4);border-radius:8px;color:#fff}", ""]);
// Exports
module.exports = exports;
